export const version="0.3.2"
export const build = 163

export const project = {
    "dev":"Narravero Web Tracer DEV",
    "test":"Narravero Web Tracer TEST",
    "prod":"Narravero Web Tracer",
    "emulator":"Local EMULATOR"
}


